import axios from 'axios'
import { IhLogUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

/**
 * 日志删除接口
 * 电池电量记录删除
 * @param {*} params
 */
export function batterysDelete(params) {
  const url = IhLogUrl + '/batterys/batch/delete'

  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '电池电量记录删除', res)
    }
    return Promise.resolve(res.data)
  })
}
/**
 * 日志删除接口
 * 模块运行记录删除
 * @param {*} params
 */
 export function modulesDelete(params) {
  const url = IhLogUrl + '/modules/batch/delete'

  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '模块运行记录删除', res)
    }
    return Promise.resolve(res.data)
  })
}
/**
 * 日志删除接口
 *  媒体上传记录删除
 * @param {*} params
 */
 export function mediaUploadInfoDelete(params) {
  const url = IhLogUrl + '/mediaUploadInfo/batch/delete'

  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', ' 媒体上传记录删除', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 日志删除接口
 *  电子围栏记录删除
 * @param {*} params
 */
 export function geoFencesDelete(params) {
  const url = IhLogUrl + '/geoFences/batch/delete'

  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', ' 电子围栏记录删除', res)
    }
    return Promise.resolve(res.data)
  })
}
/**
 * 日志删除接口
 * 数据流量记录删除
 * @param {*} params
 */
 export function mobileDatasDelete(params) {
  const url = IhLogUrl + '/mobileDatas/batch/delete'

  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '数据流量记录删除', res)
    }
    return Promise.resolve(res.data)
  })
}
/**
 * 日志删除接口
 *  通话信息记录删除
 * @param {*} params
 */
 export function callsDelete(params) {
  const url = IhLogUrl + '/calls/batch/delete'

  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', ' 通话信息记录删除', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 日志删除接口
 * 一键求助记录删除
 * @param {*} params
 */
 export function emergencyHelpDelete(params) {
  const url = IhLogUrl + '/emergencyHelp/batch/delete'

  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '一键求助记录删除', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 日志删除接口
 *  后台操作记录删除
 * @param {*} params
 */
 export function operationsDelete(params) {
  const url = IhLogUrl + '/operations/batch/delete'

  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '后台操作记录删除', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 日志删除接口
 * RFID标签数据记录删除
 * @param {*} params
 */
 export function rfidsDelete(params) {
  const url = IhLogUrl + '/rfids/batch/delete'

  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', ' RFID标签数据删除', res)
    }
    return Promise.resolve(res.data)
  })
}
/**
 * 日志删除接口
 *  轨迹删除
 * @param {*} params
 */
 export function gpsDelete(params) {
  const url = IhLogUrl + '/gps/batch/delete'

  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', ' 轨迹删除', res)
    }
    return Promise.resolve(res.data)
  })
}
/**
 * 日志删除接口
 * 安卓设备告警删除
 * @param {*} params
 */
 export function warningsDelete(params) {
  const url = IhLogUrl + '/warnings/batch/delete'

  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', ' 安卓设备告警删除', res)
    }
    return Promise.resolve(res.data)
  })
}
